"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveLightAdminFailure = exports.saveLightAdminSuccessful = exports.editLightAdminRequest = exports.createLightAdminRequest = void 0;
const ActionTypes = require("../../actionTypes/project/lightAdmin");
const createLightAdminRequest = ({ projectId, categoryId, name, description, inviteRightsTo }) => ({
    type: ActionTypes.CREATE_LIGHT_ADMIN_REQUEST,
    payload: {
        pathVariables: {
            projectId
        },
        body: {
            projectId,
            categoryId,
            name,
            description,
            inviteRightsTo
        }
    }
});
exports.createLightAdminRequest = createLightAdminRequest;
const editLightAdminRequest = (params) => ({
    type: ActionTypes.EDIT_LIGHT_ADMIN_REQUEST,
    payload: {
        pathVariables: {
            projectId: params.projectId,
            id: params.id
        },
        body: {
            name: params.name,
            description: params.description,
            inviteRightsTo: params.inviteRightsTo
        }
    }
});
exports.editLightAdminRequest = editLightAdminRequest;
const saveLightAdminSuccessful = () => ({
    type: ActionTypes.SAVE_LIGHT_ADMIN_SUCCESS
});
exports.saveLightAdminSuccessful = saveLightAdminSuccessful;
const saveLightAdminFailure = (error) => ({
    type: ActionTypes.SAVE_LIGHT_ADMIN_FAILURE,
    payload: error
});
exports.saveLightAdminFailure = saveLightAdminFailure;
//# sourceMappingURL=lightAdmin.js.map